
import { mapActions, mapGetters } from "vuex";
import Form from "./Form.vue";
import AmbienteData from "./AmbienteData";

export default {
  name: "app-restaurante-ambientes-update",
  data() {
    return {
      ambiente: new AmbienteData({}),
    };
  },
  components: {
    Form,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getAmbiente(id) {
      try {
        const { data } = await this.$http.post("/restaurante/ambientes/find", {
          id: id,
        });
        return data;
      } catch (error) {
        return null;
      }
    },
    async getInit() {
      try {
        const id = this.$route.params.id;

        this.setLoading(true);
        const ambiente = await this.getAmbiente(id);
        this.setLoading(false);

        if (!ambiente || !ambiente.id) {
          this.$router.push({ name: "restauranteAmbientes" });
          return this.$toast.error("Ambiente não encontrado!");
        }

        this.ambiente = new AmbienteData(ambiente);
      } catch {
        this.setLoading(false);
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getInit();
  },
};
